<mat-progress-bar mode="indeterminate" *ngIf="!isDataLoaded" class="sdp-progress-bar"></mat-progress-bar>
<h2>
	{{ "gateways.title" | translate }}
</h2>
<div class="sdp-section-header-description">
	{{ "gateways.info.block.1" | translate }}
	<div class="sdp-refresh-from-header">
		<button
			mat-icon-button
			(click)="refresh()"
			color="primary"
			class="sdp-icon-button"
			matTooltip="{{ 'gateways.refresh.tooltip' | translate }}"
		>
			<mat-icon class="sdp-icon-button-icon">refresh</mat-icon>
		</button>
	</div>
</div>
<mat-card class="sdp-generic-grid sdp-sessions">
	<div *ngIf="!errorMessage">
		<sdp-gateway-pending
			*ngIf="!!pendingGatewaysData && pendingGatewaysData.length > 0"
			[pendingGatewaysData]="pendingGatewaysData"
		></sdp-gateway-pending>
		<div class="sdp-gateway-skeleton-flex" *ngIf="!isDataLoaded">
			<div class="sdp-gateway-skeleton sdp-gateway-skeleton-circle"></div>
			<div class="sdp-gateway-skeleton-line-container">
				<div class="sdp-gateway-skeleton sdp-gateway-skeleton-line"></div>
				<div class="sdp-gateway-skeleton sdp-gateway-skeleton-line"></div>
			</div>
		</div>
		<div class="sdp-gateway-skeleton-flex" *ngIf="!isDataLoaded">
			<div class="sdp-gateway-skeleton sdp-gateway-skeleton-circle"></div>
			<div class="sdp-gateway-skeleton-line-container">
				<div class="sdp-gateway-skeleton sdp-gateway-skeleton-line"></div>
				<div class="sdp-gateway-skeleton sdp-gateway-skeleton-line"></div>
				<div class="sdp-gateway-skeleton sdp-gateway-skeleton-line"></div>
			</div>
		</div>
		<mat-radio-group [(ngModel)]="selectedGatewayType">
			<div class="sdp-gateway-cloud-container" *ngIf="isDataLoaded">
				<mat-radio-button
					value="cloud"
					(click)="makeCloudActive()"
				>
					{{ "sdp.gateway.cloud.radio.text" | translate }}</mat-radio-button>
				-- {{ "sdp.label.ip" | translate }}: {{ cloudGateway.host }}
				<p class="sdp-indent">{{ "gateway.description.cloud" | translate }}</p>
			</div>
			<div class="sdp-gateway-private-container" *ngIf="isDataLoaded">
				<mat-radio-button
					value="private"
					(click)="makePrivateActive()"
					[disabled]="!hasPrivateGateways"
				>
					{{ "sdp.gateway.private.radio.text" | translate }}</mat-radio-button>
				<div
					class="sdp-gateways-no-active-gateway"
					*ngIf="hasData && selectedGatewayType === 'private' && noActiveGateways"
				>
					<sdp-icon
						class="sdp-gateways-no-active-gateway-icon"
						[icon]="warnIcon"
					></sdp-icon>
					<span class="sdp-gateways-no-active-gateway-message">{{ "gateway.no.active.gateway.message" | translate }}</span>
				</div>
				<div *ngIf="accountInfoPending; else accountInfoReady">
					<p
						class="sdp-indent"
						class="loading"
					>Loading. Please wait while data is being fetched. Loading.
						Please wait while data is being fetched. Loading. Please wait while data is being fetched.</p>
				</div>
				<ng-template #accountInfoReady>
					<div *ngIf="isPrivateGatewayFeatureFlagEnabled; else privateGatewaysFeatureFlagDisabledText">
						<p class="sdp-indent">{{ "gateway.description.private.enabled" | translate }}</p>
						<div>
							<span
								class="sdp-gateway-download-link sdp-link"
								routerLink="/administration/gateways/download"
							>{{ "gateways.download.name" | translate }}</span>
							{{ "gateways.download.text" | translate }}
						</div>
					</div>
					<ng-template #privateGatewaysFeatureFlagDisabledText>
						<p
							class="sdp-indent"
							[innerHTML]='disabledText'
						>
						</p>
					</ng-template>
				</ng-template>
				<sdp-gateway-joined
					[gatewaysData]="gatewaysData"
					*ngIf="hasPrivateGateways"
				></sdp-gateway-joined>
			</div>
		</mat-radio-group>
	</div>
	<div *ngIf="!!errorMessage">
		{{ errorMessage }}
		<a href="mailto:{{ supportEmail }}">{{ supportEmail }}</a>
		<div class="sdp-session-error-retry-button">
			<button
				color="accent"
				(click)="refresh()"
				mat-raised-button
			>{{ "error.retry.message" | translate }}</button>
		</div>
	</div>
</mat-card>